import { useParams, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

import { useGlobalContext } from '../../../../../context/ContextGlobal'
import { Path } from '../../../../../router/paths'
import { getDocument, updateDocument } from '../../../../../firebase/firestore'
import { TryCatch } from '../../../../../utils/general'
import { schemaAlert, schemaNotices } from '../utils/schemas'

const useEditNotices = () => {
  const { id } = useParams()
  const {
    // user,
    setAlerts,
    // dataContext, tudo que for dados da página, e.g: listas
    // setDataContext,
    // infosContext, todas as informações para a página funcionar
    // setInfosContext,
    formContext,
    setFormContext,
    loading,
    setLoading,
    // statusLoading,
    // setStatusLoading,
  } = useGlobalContext()

  const navigate = useNavigate()

  const getForm = async () => {
    if (id === 'vf9USQTsdGh1bdrqRk6K') {
      const getAlert = await getDocument('_alertsApp', id)
      const newAlert = schemaAlert(getAlert)

      setFormContext(newAlert)
    } else {
      const getNotice = await getDocument('notices', id)
      const newNotice = schemaNotices(getNotice)
      setFormContext(newNotice)
    }
  }

  const fetchGetForm = async () => {
    await TryCatch(getForm, setLoading, setAlerts)
  }

  const editNotice = async () => {
    if (id === 'vf9USQTsdGh1bdrqRk6K') {
      const newAlert = schemaAlert(formContext)

      const timestamp = new Date(formContext?.expiredAt).getTime()

      const editingToTimeStamp = { ...newAlert, expiredAt: timestamp }

      await updateDocument('_alertsApp', id, editingToTimeStamp)

      setAlerts((prev) => [
        ...prev,
        {
          type: 'success',
          title: 'Alerta Editado',
          msg: `A Mensagem de alertas Rápidos foi editado com sucesso.`,
        },
      ])

      setFormContext({})
      return navigate(Path.AdminNotices)
    }
    const newNotice = schemaNotices(formContext)

    await updateDocument('notices', id, newNotice)

    setAlerts((prev) => [
      ...prev,
      {
        type: 'success',
        title: 'Aviso Editado',
        msg: `O Aviso "${newNotice?.name || ''}" foi editado com sucesso.`,
      },
    ])

    setFormContext({})
    return navigate(Path.AdminNotices)
  }

  const handleEditNotice = async () => {
    await TryCatch(editNotice, setLoading, setAlerts)
  }

  useEffect(() => {
    fetchGetForm()
  }, [])

  return { loading, formContext, setFormContext, handleEditNotice }
}

export default useEditNotices
